<template>
  <LazyHydrate v-bind="hydrationStrategy">
    <StandardWrapper v-bind="$attrs" :blok="blok" width="full" no-padding>
      <div
        class="relative sm:overflow-hidden"
        :class="{
          'h-80 sm:h-96 md:h-120 lg:h-120 xl:h-152': !blok.useImageHeight,
        }"
      >
        <div :class="{ 'absolute inset-0': !blok.useImageHeight }">
          <img
            :src="getImgSrc({ imgUrl, smart: true })"
            class="h-full w-full object-center"
            :class="imgClass"
            :alt="imgAlt"
            :srcset="
              getImgSrcset({
                imgUrl,
                smart: true,
                widths: [512, 640, 1024, 1920, 2048],
              })
            "
            sizes="100vw"
            loading="lazy"
          />
          <div
            v-if="blok.showOverlay"
            class="absolute inset-0 mix-blend-multiply"
            :class="overlayClass"
          />
          <div
            v-if="blok.callToActionButtons && blok.callToActionButtons.length"
            class="absolute inset-0 flex flex-wrap content-center items-center justify-center"
          >
            <CallToActionButton
              v-for="btn in blok.callToActionButtons"
              :key="btn._uid"
              :item="btn"
              :blok="blok"
              class="m-8 block w-max lg:m-4"
            />
          </div>
        </div>
      </div>
    </StandardWrapper>
  </LazyHydrate>
</template>

<script setup>
import { computed } from 'vue'
import StandardWrapper from '../components/StandardWrapper.vue'
import CallToActionButton from '../components/CallToActionButton.vue'
import { useColorPalette } from '../composables/colorPalette'
import { getImgSrc, getImgSrcset } from '../utils/imgUtils'

const props = defineProps({
  blok: {
    type: Object,
    default: () => {},
  },
  context: {
    type: Object,
    default: () => {},
  },
})

const { colorName } = useColorPalette()

const hydrationStrategy = computed(() => {
  if (props.blok.callToActionButtons?.length) {
    return {
      onInteraction: ['focus'],
    }
  } else {
    // If it doesn't have any button, it doesn't need hydration
    return { whenTriggered: false }
  }
})
const imgUrl = computed(() => {
  return props.blok.image?.filename || props.blok.imgUrl
})
const overlayClass = computed(() => {
  if (!props.blok.overlayColor) {
    return 'bg-primary-700'
  }
  // TODO This doesn't work with new color system
  const colorMap = {
    primary: 'bg-primary-700',
    secondary: 'bg-secondary-700',
    tertiary: 'bg-tertiary-700',
    fourth: 'bg-fourth-700',
    dark: 'bg-gray-700',
    light: 'bg-white', // white doesn't do anything in multiply mode
  }
  return (
    colorMap[props.blok.overlayColor] ||
    `bg-${colorName(props.blok.overlayColor)}`
  )
})
const imgClass = computed(() => {
  return `object-${props.blok.fitType}`
  // object-none object-contain object-cover object-fill object-scale-down
})
const imgAlt = computed(() => {
  return props.blok.image?.filename ? props.blok.image?.alt : ''
})
</script>
